import { useEffect, useState } from 'react';

export const useSaveMode = () => {
  const [isSaveMode, setIsSaveMode] = useState(false);

  useEffect(() => {
    const checkSaveMode = () => {
      const buttons = Array.from(document.querySelectorAll('button'));
      setIsSaveMode(
        buttons.some(btn => btn.textContent?.trim().toLowerCase() === 'save'),
      );
    };

    checkSaveMode();
    const observer = new MutationObserver(checkSaveMode);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return isSaveMode;
};
